
import { css } from 'lit';
export default css`
.checkbox {
  position: relative;
  display: flex;
  align-items: center;
}

  .checkbox--spacing {
  margin-bottom: 1rem;
}

  .checkbox__icon {
  height: 0.75rem;
}

  .checkbox__icon {
  width: 0.75rem;
}

  .checkbox__icon {
  fill: currentColor;
}

  .checkbox__icon {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .checkbox__box-container--radio .checkbox__icon {
  height: 0.25rem;
}

  .checkbox__box-container--radio .checkbox__icon {
  width: 0.25rem;
}

  .checkbox__box-container--radio .checkbox__icon {
  border-radius: 9999px;
}

  .checkbox__box-container--radio .checkbox__icon {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

  .checkbox__label {
  cursor: pointer;
}

  .checkbox__label {
  padding-left: 2rem;
}

  .checkbox__label {
  font-family: Lato, sans-serif;
}

  .checkbox__label {
  font-size: 1.125rem;
}

  @media (min-width: 1024px) {

  .checkbox__label {
    font-size: 1.25rem;
  }
}

  .checkbox__input {
  visibility: hidden;
}

  .checkbox__input {
  height: 0px;
}

  .checkbox__input {
  width: 0px;
}

  .checkbox__box-container {
  position: absolute;
}

  .checkbox__box-container {
  z-index: -10;
}

  .checkbox__box-container {
  display: flex;
}

  .checkbox__box-container {
  height: 1.25rem;
}

  .checkbox__box-container {
  width: 1.25rem;
}

  .checkbox__box-container {
  align-items: center;
}

  .checkbox__box-container {
  justify-content: center;
}

  .checkbox__box-container {
  border-width: 1px;
}

  .checkbox__box-container {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}

  .checkbox__box-container--radio {
  border-radius: 9999px;
}

  .checkbox__box-container--radio.checkbox__box-container--checked {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

  .checkbox__box-container--radio.checkbox__box-container--checked {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

  .checkbox__box-container--checkbox {
  border-radius: 0.125rem;
}

  .checkbox__box-container--checkbox {
  border-style: solid;
}

  .checkbox__box-container--checkbox {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

  .checkbox__box-container--checkbox:not(.checkbox__box-container--checkbox--checked) {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}

  .checkbox--checked .checkbox__label {
  font-weight: 700;
}

  .checkbox--checked .checkbox__box-container {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

  .checkbox--checked .checkbox__box-container {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

  .checkbox--disabled .checkbox__box-container {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}

  .checkbox--disabled .checkbox__box-container {
  --tw-bg-opacity: 1;
  background-color: rgba(164, 167, 171, var(--tw-bg-opacity));
}

  .checkbox--disabled .checkbox__label {
  cursor: default;
}

  .checkbox--search-filter .checkbox__label {
  font-weight: 400;
}

  .checkbox--search-filter .checkbox__label {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

  .checkbox--search-filter .checkbox__label {
      font-size: 20px;
      line-height: 24px;
      text-align: left;
    }

  .checkbox--search-filter.checkbox--checked .checkbox__label {
  font-weight: 900;
}
`;